import React, { useEffect, useState } from "react";
import { mediaUrl } from "@/lib/api";

export function ProductImage({
  src,
  alt,
  category,
  className,
  style,
  width,
}: {
  src?: string;
  alt: string;
  category?: string;
  className?: string;
  style?: React.CSSProperties;
  /** Ask the server for a lighter copy (catalogue cards, thumbnails). */
  width?: 200 | 400 | 800;
}) {
  const resolved = mediaUrl(src, width);
  const [failed, setFailed] = useState(!resolved);
  // Reset when the gallery switches to another photo.
  useEffect(() => setFailed(!resolved), [resolved]);

  if (failed || !resolved) {
    // No photo yet: a quiet brand mark on the card's tinted ground.
    return (
      <div
        className={className}
        style={{ display: "grid", placeItems: "center", mixBlendMode: "normal", ...style }}
        role="img"
        aria-label={alt}
        data-category={category}
      >
        <img src="/brand/kms-logo.png" alt="" style={{ width: "46%", maxWidth: 140, opacity: 0.16 }} />
      </div>
    );
  }

  return <img src={resolved} alt={alt} className={className} style={style} onError={() => setFailed(true)} loading="lazy" />;
}
